import { useCity } from '../hooks/useLocales';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default ({ country, state, onChange, value, ...props }) => {
    const { data } = useCity({ country, state });
    return (
        <Autocomplete
            {...props}
            getOptionLabel={render => render.name}
            options={data ? data : []}
            onChange={(e, value) => onChange(Boolean(value)?value.name: '')}
            value={data && (data.filter(({ name }) => name === value)[0] || null)}
            loading={!Boolean(data)}
            disablePortal
            id="cidade-select"
            sx={{ width: '100%' }}
            renderInput={params => <TextField {...params} label="Cidade" />}
        />
    );
};
